/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import breakpoints from "assets/theme/base/breakpoints";

const dialogActions = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
      gap: pxToRem(8),

      // Mobile optimizations
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        padding: pxToRem(12),
        flexDirection: "column-reverse",
        gap: pxToRem(8),

        "& .MuiButton-root": {
          width: "100%",
          minHeight: "44px", // Touch-friendly button height
          fontSize: "0.875rem",
        },
      },

      [`@media (max-width: ${breakpoints.values.xs + 100}px)`]: {
        padding: pxToRem(8),

        "& .MuiButton-root": {
          minHeight: "48px", // Even more touch-friendly
          fontSize: "1rem",
        },
      },
    },
  },
};

export default dialogActions;
